'use client'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select'
import { useOptimistic, useTransition } from 'react'
import { SalesChannel } from '@/lib/api/shopware/shopware.types'
import { useSession } from '@/lib/queries/session'
import { useAuthDialogStore } from '@/components/custom-ui/auth-forms/auth-dialog.store'
import { setSalesChannel } from './channel-switcher.actions'

const selectableChannels = ['B2C-CH', 'B2C-EU'] as const satisfies SalesChannel[]

const B2B_OPTION = 'B2B'
const formatChannel = (channel: string) => channel.replace('-', ' / ')

interface ChannelSwitcherProps {
  salesChannel: SalesChannel
}

const ChannelSwitcher = ({ salesChannel }: ChannelSwitcherProps) => {
  const [selected, setSelected] = useOptimistic(salesChannel)
  const [, startTransition] = useTransition()
  const { data: session } = useSession()
  const toggleShowDialog = useAuthDialogStore()((s) => s.toggleShowDialog)

  if (session) return null

  const handleSelect = (value: string) => {
    if (value === B2B_OPTION) {
      if (!session) toggleShowDialog()
      return
    }

    startTransition(() => {
      setSelected(value as SalesChannel)
      setSalesChannel(value as SalesChannel)
    })
  }

  return (
    <Select value={selected} onValueChange={handleSelect}>
      <SelectTrigger className="hidden h-auto w-auto gap-1 border-0 bg-transparent p-0 text-sm uppercase text-black sm:flex">
        <span>{formatChannel(selected)}</span>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {selectableChannels.map((channel) => (
            <SelectItem key={channel} value={channel} className="uppercase">
              {formatChannel(channel)}
            </SelectItem>
          ))}
          <SelectItem value={B2B_OPTION} className="uppercase">
            {B2B_OPTION}
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default ChannelSwitcher
